import React, { PureComponent } from 'react';
import { Field, reduxForm } from 'redux-form';
import EyeIcon from 'mdi-react/EyeIcon';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import AtIcon from 'mdi-react/AtIcon';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Alert from '../../../../shared/components/Alert';
import { userActions, alertActions } from '../../../../redux/actions';
import InvisibleRecaptcha from '../../../../shared/components/InvisibleRecaptcha';
import { SiteName, getCorprateUrl } from '../../../../shared/components/domainSupport';
import LoadingSpinner from '../../../../shared/components/widgets/LoadingSpinner';
import { getLocalStorage } from '../../../../shared/storage';
import { getContinueParam, isAllowedContinue } from '../../../../helpers/continue';

class LogInForm extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    // loggingIn: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      email: '',
      password: '',
      submitted: false,
    };
    this.recaptchaRef = React.createRef();

    // reset login status
    const { dispatch } = this.props;
    dispatch(userActions.logout());

    this.showPassword = this.showPassword.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    // Remove the email address that the old "Remember me" feature stored in this browser.
    // TODO: Remove this cleanup a few months after the Remember me removal is deployed (Oct 2026),
    // once active users have passed through the login page. localStorage never expires on its own.
    localStorage.removeItem('rememberMe');
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  async handleSubmit(e) {
    e.preventDefault();
    localStorage.removeItem('loginMessage'); // clear message

    this.setState({ submitted: true });
    const { email, password } = this.state;
    const { dispatch } = this.props;
    if (email && password) {
      let recaptcha;
      try {
        recaptcha = await this.recaptchaRef.current.execute();
      } catch (err) {
        dispatch(alertActions.error('We could not verify you are not a robot. Please try again.'));
        return;
      }
      if (window.location.pathname === '/link/walmart/marketplace') {
        dispatch(userActions.linkWmMp(email, password, recaptcha));
      } else {
        dispatch(userActions.login(email, password, recaptcha));
      }
    }
  }

  showPassword(e) {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  }

  render() {
    // userActions.logout(); // We should not have a user on the login page.
    // eslint-disable-next-line
    const { loggingIn, alert } = this.props;
    const cont = getContinueParam();
    const willRedirect = cont && isAllowedContinue(cont);

    // This can be cleaned up if we can figure out how to set the error at the App level (connect(map)(App))
    // But I was having issues with the hot loader.  Also needed to refresh for Captcha
    const loginMessage = JSON.parse(getLocalStorage('loginMessage'));

    const {
      showPassword, email, password, submitted,
    } = this.state;

    return (
      <form className="form" onSubmit={this.handleSubmit}>
        <div className="form__form-group">
          {alert && alert.message && (
            <Alert className={alert.type}>{alert.message}</Alert>
          )}
        </div>
        {willRedirect && (
          <div className="form__form-group">
            <Alert className="alert-info">
              After login, you’ll be redirected back to your app though a secure connection.
            </Alert>
          </div>
        )}
        <div className="form__form-group">
          {loginMessage && loginMessage.message && (
            <Alert className={loginMessage.type}>{loginMessage.message}</Alert>
          )}
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">Username</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <AtIcon />
            </div>
            <Field
              autoFocus
              name="email"
              component="input"
              type="email"
              placeholder="example@mail.com"
              value={email}
              onChange={this.handleChange}
            />
          </div>
          {submitted && !email && (
            <div className="form__form-group-error">Email is required</div>
          )}
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">Password</span>
          <div className="form__form-group-field">
            <div className="form__form-group-icon">
              <KeyVariantIcon />
            </div>
            <Field
              name="password"
              component="input"
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              value={password}
              onChange={this.handleChange}
            />
            <button
              type="button"
              className={`form__form-group-button${showPassword ? ' active' : ''}`}
              onClick={e => this.showPassword(e)}
            ><EyeIcon />
            </button>
          </div>
          {submitted && !password && (
            <div className="form__form-group-error">Password is required</div>
          )}
          <div className="account__forgot-password">
            <a href="/forgot">Forgot a password?</a>
          </div>
        </div>
        <InvisibleRecaptcha ref={this.recaptchaRef} />
        <div className="form__form-group form__center" style={{ marginTop: '40px' }}>
          <div className="form__inline">
            <p>By logging into this site you agree to {SiteName()}&apos;s <a href={`${getCorprateUrl()}/terms-of-use`} target="blank">Terms &amp; Conditions</a></p>
          </div>
        </div>
        <LoadingSpinner
          active={loggingIn}
        />
        <div className="form__form-group">
          <button className="btn btn-primary account__btn" type="submit" disabled={loggingIn}>Login</button>
          <Link className="btn btn-outline-primary account__btn" to="/register">Create Account</Link>
        </div>
      </form>
    );
  }
}

const logInForm = reduxForm({
  form: 'login_form',
})(LogInForm);

const mapStateToProps = (state) => {
  const { alert } = state;
  const { loggingIn } = state.authentication;

  return {
    alert,
    loggingIn,
  };
};

export default connect(mapStateToProps)(logInForm);
